import i18next from 'i18next';

const useSolutionPages = () => {
  const len = i18next.language.substring(0, 2);
  return [
    { title: 'For Physicians', link: `/${len}/solutions/physicians` },
    { title: 'For Healthcare Providers', link: `/${len}/solutions/healthcare-providers` },
    { title: 'For Mental Health Therapists', link: `/${len}/solutions/mental-health-therapists` },
  ];
};

export default useSolutionPages;
